<p-card header="CHEP Misc Info">
  <form [formGroup]="chepMiscInfoForm">
    <div class="p-grid">
      <div class="form-group p-col-6">
        <div class="p-grid">
          <div class="form-group p-col-6">
            <label class="required" for="cbRepairsAwaitingPrep">Await CB Prep</label>
          </div>
          <div class="form-group p-col-6">
            <input type="number" pInputText class="form-control chepInput" id="cbRepairsAwaitingPrep" name="cbRepairsAwaitingPrep"
              formControlName="cbRepairsAwaitingPrep" lib-numeric>
            <error-block [field]="chepMiscInfoForm.controls.cbRepairsAwaitingPrep" [messages]="{
              required: 'Await CB Prep is required.',
              numeric: 'Await CB Prep must be a number.'
            }"></error-block>
          </div>
        </div>
        <div class="p-grid">
          <div class="form-group p-col-6">
            <label class="required" for="cbRepairsPrepped">CBs Prepped</label>
          </div>
          <div class="form-group p-col-6">
            <input type="number" pInputText class="form-control chepInput" id="cbRepairsPrepped" name="cbRepairsPrepped"
              formControlName="cbRepairsPrepped" lib-numeric>
            <error-block [field]="chepMiscInfoForm.controls.cbRepairsPrepped" [messages]="{
              required: 'CBs Prepped is required.',
              numeric: 'CBs Prepped must be a number.'
            }"></error-block>
          </div>
        </div>
        <div class="p-grid">
          <div class="form-group p-col-6">
            <label class="required" for="cbRepairPrepHours">CBs Prep Hours</label>
          </div>
          <div class="form-group p-col-6">
            <time-entry
              [showButton]="false"

              [only24Hours]="false"
              formControlName="cbRepairPrepHours">
            </time-entry>
            <error-block [field]="chepMiscInfoForm.controls.cbRepairPrepHours" [messages]="{
              required: 'CBs Prep Hours is required.'
            }"></error-block>

          </div>
        </div>
        <div class="p-grid">
          <div class="form-group p-col-6">
            <label class="required" for="cbRepairsReady">Awaiting CB Repair</label>
          </div>
          <div class="form-group p-col-6">
            <input type="number" pInputText class="form-control chepInput" id="cbRepairsReady"
              name="cbRepairsReady" formControlName="cbRepairsReady" lib-numeric>
            <error-block [field]="chepMiscInfoForm.controls.cbRepairsReady" [messages]="{
              required: 'Awaiting CB Repair is required.',
              numeric: 'Awaiting CB Repair must be a number.'
            }"></error-block>
          </div>
        </div>

        <div class="p-grid">
          <div class="form-group p-col-6">
            <label class="required" for="multicolorArMediaBlasted">AR Pallets Media Blasted</label>
          </div>
          <div class="form-group p-col-6">
            <input type="number" pInputText class="form-control chepInput" id="multicolorArMediaBlasted"
              name="multicolorArMediaBlasted" formControlName="multicolorArMediaBlasted" lib-numeric>
            <error-block [field]="chepMiscInfoForm.controls.multicolorArMediaBlasted" [messages]="{
              required: 'AR Pallets Media Blasted is required.',
              numeric: 'AR Pallets Media Blasted must be a number.'
            }"></error-block>
          </div>
        </div>
        <div class="p-grid">
          <div class="form-group p-col-6">
            <label class="required" for="multicolorRuMediaBlasted">RU Pallets Media Blasted</label>
          </div>
          <div class="form-group p-col-6">
            <input type="number" pInputText class="form-control chepInput" id="multicolorRuMediaBlasted"
              name="multicolorRuMediaBlasted" formControlName="multicolorRuMediaBlasted" lib-numeric>
            <error-block [field]="chepMiscInfoForm.controls.multicolorRuMediaBlasted" [messages]="{
              required: 'RU Pallets Media Blasted is required.',
              numeric: 'RU Pallets Media Blasted must be a number.'
            }"></error-block>
          </div>
        </div>
      </div>
      <div class="form-group p-col-6">
        <div class="p-grid">
          <div class="form-group p-col-6">
            <label class="required" for="repairHoursUsedForTdwn">Repairs Hours User for Teardowns</label>
          </div>
          <div class="form-group p-col-6">
            <time-entry
              [showButton]="false"

              [only24Hours]="false"
              formControlName="repairHoursUsedForTdwn">
            </time-entry>
            <error-block [field]="chepMiscInfoForm.controls.repairHoursUsedForTdwn" [messages]="{
              required: 'Repairs Hours User for Teardowns is required.'
            }"></error-block>
          </div>
        </div>
        <div class="p-grid">
          <div class="form-group p-col-6">
            <label class="required" for="palletsWashed">Pallets Washed</label>
          </div>
          <div class="form-group p-col-6">
            <input type="number" pInputText class="form-control chepInput" id="palletsWashed" name="palletsWashed"
              formControlName="palletsWashed" lib-numeric>
            <error-block [field]="chepMiscInfoForm.controls.palletsWashed" [messages]="{
              required: 'Pallets Washed is required.',
              numeric: 'Pallets Washed must be a number.'
            }"></error-block>
          </div>
        </div>
        <div class="p-grid">
          <div class="form-group p-col-6">
            <label class="required" for="palletsRewashed">Pallets ReWashed</label>
          </div>
          <div class="form-group p-col-6">
            <input type="number" pInputText class="form-control chepInput" id="palletsRewashed"
              name="palletsRewashed" formControlName="palletsRewashed" lib-numeric>
            <error-block [field]="chepMiscInfoForm.controls.palletsRewashed" [messages]="{
              required: 'Pallets ReWashed is required.',
              numeric: 'Pallets ReWashed must be a number.'
            }"></error-block>
          </div>
        </div>
        <div class="p-grid">
          <div class="form-group p-col-6">
            <label class="required" for="stackerRepairCount">Repair Stacker Count</label>
          </div>
          <div class="form-group p-col-6">
            <input type="number" pInputText class="form-control chepInput" id="stackerRepairCount"
              name="stackerRepairCount" formControlName="stackerRepairCount" lib-numeric>
            <error-block [field]="chepMiscInfoForm.controls.stackerRepairCount" [messages]="{
              required: 'Repair Stacker Count is required.',
              numeric: 'Repair Stacker Count must be a number.'
            }"></error-block>
          </div>
        </div>
        <div class="p-grid">
          <div class="form-group p-col-6">
            <label class="required" for="forkliftRepairCount">Forklift Driver Count</label>
          </div>
          <div class="form-group p-col-6">
            <input type="number" pInputText class="form-control chepInput" id="forkliftRepairCount"
              name="forkliftRepairCount" formControlName="forkliftRepairCount" lib-numeric>
            <error-block [field]="chepMiscInfoForm.controls.forkliftRepairCount" [messages]="{
              required: 'Forklift Driver Count is required.',
              numeric: 'Forklift Driver Count must be a number.'
            }"></error-block>
          </div>
        </div>
        <div class="p-grid">
          <div class="form-group p-col-6">
            <label class="required" for="directionalRepTotalSort">Directional Repair Total Sort</label>
          </div>
          <div class="form-group p-col-6">
            <input type="number" pInputText class="form-control chepInput" id="directionalRepTotalSort"
                   name="directionalRepTotalSort" formControlName="directionalRepTotalSort" lib-numeric>
            <error-block [field]="chepMiscInfoForm.controls.directionalRepTotalSort" [messages]="{
              required: 'Directional Repair Total Sort is required.',
              numeric: 'Directional Repair Total Sort must be a number.'
            }"></error-block>
          </div>
        </div>
      </div>
    </div>
    <div>
      <p-table *ngIf="hasActivity()" [value]="[{}]">
        <ng-template pTemplate="header">
          <tr>
            <th></th>
            <th *ngIf="hasPlusActivity() && hasPremActivity()" >PLUS to PREM</th>
            <th *ngIf="hasPlusActivity() && hasCustActivity()" >PLUS to CUST</th>
            <th *ngIf="hasPremActivity() && hasCustActivity()" >PREM to CUST</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
          <tr *ngIf="!hasBlockActivity()">
            <td class="centered">
              REP Sort
            </td>
            <td *ngIf="hasPlusActivity() && hasPremActivity()" class="centered">
              <input type="number" pInputText class="form-control chepInput" id="repPlusToPrem" name="repPlusToPrem"
                name="repPlusToPrem" formControlName="repPlusToPrem" lib-numeric>
              <error-block [field]="chepMiscInfoForm.controls.repPlusToPrem" [messages]="{
                required: 'PLUS REP to PREM is required.',
                numeric: 'PLUS REP to PREM must be a number.'
              }"></error-block>
            </td>
            <td *ngIf="hasPlusActivity() && hasCustActivity()" class="centered">
              <input type="number" pInputText class="form-control chepInput" id="repPlusToCust" name="repPlusToCust"
                name="repPlusToCust" formControlName="repPlusToCust" lib-numeric>
              <error-block [field]="chepMiscInfoForm.controls.repPlusToCust" [messages]="{
                required: 'PLUS REP to CUST is required.',
                numeric: 'PLUS REP to CUST must be a number.'
              }"></error-block>
            </td>
            <td *ngIf="hasPremActivity() && hasCustActivity()" class="centered">
              <input type="number" pInputText class="form-control chepInput" id="repPremToCust" name="repPremToCust"
                name="repPremToCust" formControlName="repPremToCust" lib-numeric>
              <error-block [field]="chepMiscInfoForm.controls.repPremToCust" [messages]="{
                required: 'PREM REP to CUST is required.',
                numeric: 'PREM REP to CUST must be a number.'
              }"></error-block>
            </td>
          </tr>
          <tr>
            <td class="centered">
              SRT Sort
            </td>
            <td *ngIf="hasPlusActivity() && hasPremActivity()" class="centered">
              <input type="number" pInputText class="form-control chepInput" id="srtPlusToPrem" name="srtPlusToPrem"
                name="srtPlusToPrem" formControlName="srtPlusToPrem" lib-numeric>
              <error-block [field]="chepMiscInfoForm.controls.srtPlusToPrem" [messages]="{
                required: 'PLUS SRT to PREM is required.',
                numeric: 'PLUS SRT to PREM must be a number.'
              }"></error-block>
            </td>
            <td *ngIf="hasPlusActivity() && hasCustActivity()" class="centered">
              <input type="number" pInputText class="form-control chepInput" id="srtPlusToCust" name="srtPlusToCust"
                name="srtPlusToCust" formControlName="srtPlusToCust" lib-numeric>
              <error-block [field]="chepMiscInfoForm.controls.srtPlusToCust" [messages]="{
                required: 'PLUS SRT to CUST is required.',
                numeric: 'PLUS SRT to CUST must be a number.'
              }"></error-block>
            </td>
            <td *ngIf="hasPremActivity() && hasCustActivity()" class="centered">
              <input type="number" pInputText class="form-control chepInput" id="srtPremToCust" name="srtPremToCust"
                name="srtPremToCust" formControlName="srtPremToCust" lib-numeric>
              <error-block [field]="chepMiscInfoForm.controls.srtPremToCust" [messages]="{
                required: 'PREM SRT to CUST is required.',
                numeric: 'PREM SRT to CUST must be a number.'
              }"></error-block>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <br>
      <br>
      <p-table  *ngIf="hasActivity()" [value]="[{}]">
        <ng-template pTemplate="header">
          <tr>
            <th></th>
            <th *ngIf="hasPlusActivity()">to RU PLUS SRT</th>
            <th *ngIf="hasPremActivity()">to RU PREM SRT</th>
            <th *ngIf="hasCustActivity()">to RU CUST SRT</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
          <tr>
            <td class="centered">
              NM Sort
            </td>
            <td *ngIf="hasPlusActivity()" class="centered">
              <input type="number" pInputText class="form-control chepInput" id="nmToPlus" name="nmToPlus"
              name="nmToPlus" formControlName="nmToPlus" lib-numeric>
              <error-block [field]="chepMiscInfoForm.controls.nmToPlus" [messages]="{
                required: 'NM to RU PLUS is required.',
                numeric: 'NM to RU PLUS must be a number.'
              }"></error-block>
            </td>
            <td *ngIf="hasPremActivity()" class="centered">
              <input type="number" pInputText class="form-control chepInput" id="nmToPrem" name="nmToPrem"
              name="nmToPrem" formControlName="nmToPrem" lib-numeric>
              <error-block [field]="chepMiscInfoForm.controls.nmToPrem" [messages]="{
                required: 'NM to RU PREM is required.',
                numeric: 'NM to RU PREM must be a number.'
              }"></error-block>
            </td>
            <td *ngIf="hasCustActivity()" class="centered">
              <input type="number" pInputText class="form-control chepInput" id="nmToCust" name="nmToCust"
              name="nmToCust" formControlName="nmToCust" lib-numeric>
              <error-block [field]="chepMiscInfoForm.controls.nmToCust" [messages]="{
                required: 'NM to RU CUST is required.',
                numeric: 'NM to RU CUST must be a number.'
              }"></error-block>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </form>
</p-card>
